// store.js
import { configureStore } from '@reduxjs/toolkit';
import { authReducer } from './auth/reducer.jsx';

const store = configureStore({
  reducer: {
    auth: authReducer,
    // Add other reducers here as needed
  },
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;